import {
  CONFIRMED_GET_STOCK_TRANSACTIONS,
  STOCK_TRANSACTIONS_LOADING,
  STOCK_TRANSACTIONS_ERROR,
} from "../types/stockTransactionTypes";

const initialState = {
  transactions: [],
  num_rows: 0,
  loading: false,
  error: null,
};

export default function stockTransactionReducer(state = initialState, action) {
  switch (action.type) {
    case STOCK_TRANSACTIONS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CONFIRMED_GET_STOCK_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload.transactions || [],
        num_rows: action.payload.num_rows || 0,
        loading: false,
        error: null,
      };

    case STOCK_TRANSACTIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}